import { callRpc } from './rpcClient';
import { supabase } from './supabase';

let lastTrackedAt: number = 0;
const THROTTLE_MS = 60 * 1000; // 1 minute throttle for client-side calls

export async function trackUserActivity(eventType: string = 'page_view', carId?: string) {
  const now = Date.now();
  
  // Throttle only 'page_view' or generic events to avoid flooding
  if (eventType === 'page_view' && now - lastTrackedAt < THROTTLE_MS) {
    return;
  }
  
  try {
    await callRpc('track_user_event', { 
      p_event_type: eventType,
      p_car_id: carId
    });
    lastTrackedAt = now;
  } catch (err) {
    // Silent fail for activity tracking
    console.warn('Activity tracking failed:', err);
  }
}

export async function trackPricingEvent(params: {
  eventType: 'opened' | 'pressed_pro' | 'pressed_custom' | 'downgrade_to_free';
  billingCycle?: 'monthly' | 'yearly';
  feedback?: string;
}) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from('pricing_upgrade_stats').insert({
      user_id: user.id,
      event_type: params.eventType,
      billing_cycle: params.billingCycle,
      feedback: params.feedback
    });
  } catch (err) {
    console.warn('Pricing tracking failed:', err);
  }
}

export async function trackCarTasksEvent(params: {
  eventType: 'car_tasks_opened' | 'car_tasks_pressed_get_started';
  feedback?: string;
  carId?: string;
}) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from('pricing_upgrade_stats').insert({
      user_id: user.id,
      event_type: params.eventType,
      feedback: params.feedback,
      // We can use billing_cycle as a generic metadata field if needed, 
      // but for now we just track the event and feedback.
      // If we want to track which car, we might need a new column or use feedback for it.
      // But user_event table already has car_id.
    });
    
    // Also track in general user activity for dashboard visibility
    if (params.eventType === 'car_tasks_opened') {
        trackUserActivity('car_tasks_viewed', params.carId);
    }
  } catch (err) {
    console.warn('Car Tasks tracking failed:', err);
  }
}
